import axios from 'axios'
import { API_BASE_URL, TOKEN_KEY } from '@/config/api'

// 创建axios实例
const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem(TOKEN_KEY)
    if (token) {
      // 将token添加到请求头（直接使用token字段）
      config.headers['token'] = token
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 根据后端返回的code判断请求是否成功
    if (res.code === 0) {
      return res
    } else {
      // 业务错误
      console.error('业务错误:', res.msg)
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
  },
  error => {
    console.error('响应错误:', error)
    // 处理HTTP错误
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 未授权，清除token并跳转到登录页
          localStorage.removeItem(TOKEN_KEY)
          // 可以在这里触发路由跳转到登录页
          break
        case 403:
          console.error('没有权限')
          break
        case 404:
          console.error('请求的资源不存在')
          break
        case 500:
          console.error('服务器错误')
          break
        default:
          console.error('请求失败:', error.message)
      }
    }
    return Promise.reject(error)
  }
)

export default service

